import AddressHelper from 'src/app/helpers/address-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { TourHelper } from 'src/app/helpers/tour-helper';
import Coordinates from 'src/app/model/coordinates';
import Employee from 'src/app/model/product/employee';
import { Tour } from 'src/app/model/tour/tour';
import { GeocoderService } from 'src/app/services/geocoder.service';
import { AffectedTour } from '../../../service/assign-sub-project-to-tour-controller-request.service';
import { TourPreviewStateInput } from '../../../service/tour-preview-state.service';

export class EmployeeTourHelper {
  private constructor() {}

  static getPreviewInfoFromTour(tour: Tour): PreviewInfo[] {
    return tour == null ||
      tour === TourHelper.EMPTY_TOUR ||
      !CollectionHelper.isPopulated(tour.tourItems)
      ? null
      : tour.tourItems
          .map((ti) => {
            if (
              ti.subProject != null &&
              ti.subProject.address != null &&
              ti.subProject.address.coordinates != null
            ) {
              return {
                subProjectId: ti.subProject.id,
                immoTaskId: null,
                onStones: ti.subProject.onStones,
                coordinates: ti.subProject.address.coordinates,
                collectKey: false,
              };
            } else if (ti.immoTask != null && ti.immoTask.address != null) {
              return {
                subProjectId: null,
                immoTaskId: ti.immoTask.id,
                onStones: false,
                coordinates: ti.immoTask.address.coordinates,
                collectKey: ti.immoTask.type.toString() === 'COLLECT_KEY',
              };
            } else {
              return null;
            }
          })
          .filter((i) => i != null);
  }

  static affectedToursMatch(
    affectedTours: AffectedTour[],
    placerId: number,
    date: Date
  ): boolean {
    // if date == null, that means this function was called while the tour for the placer in question hadn't been loaded yet,
    // return true by default in that case
    return (
      CollectionHelper.isPopulated(affectedTours) &&
      affectedTours.some(
        (t) =>
          t != null &&
          t.placerId === placerId &&
          (date == null || DateHelper.equal(t.date, date))
      )
    );
  }

  static async getTourPreviewStateInput(
    placer: Employee,
    tour: Tour,
    geocoderService: GeocoderService
  ): Promise<TourPreviewStateInput> {
    let placerAddressCoordinates = null;
    try {
      placerAddressCoordinates =
        placer.address == null
          ? null
          : await geocoderService.geocodeAddress(
              AddressHelper.getAddressDisplay(placer.address)
            );
    } catch (error) {
      console.error(error);
    }
    const placerAddressPreviewInfo: PreviewInfo =
      placerAddressCoordinates == null
        ? null
        : {
            subProjectId: null,
            immoTaskId: null,
            onStones: false,
            coordinates: placerAddressCoordinates,
            collectKey: false,
          };
    const previewInfo = this.getPreviewInfoFromTour(tour);
    const toSetPreviewInfo =
      placerAddressPreviewInfo == null
        ? previewInfo
        : [placerAddressPreviewInfo, ...previewInfo];
    return {
      placer: placer,
      date: tour.date,
      placerAddressCoordinatesIncluded: placerAddressCoordinates != null,
      previewInfo: toSetPreviewInfo,
    };
  }
}

export interface PreviewInfo {
  subProjectId: number;
  immoTaskId: number;
  onStones: boolean;
  coordinates: Coordinates;
  collectKey: boolean;
}
